import React from "react";
import { Box } from "../design-system";
import { colors } from "../design-system/colors";

export interface UsageRowProps {
  label: string;
  usedLabel: string;
  pct: number;
}

const UsageRow = ({ label, usedLabel, pct }: UsageRowProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontFamily: "Outfit, sans-serif",
        fontWeight: 400,
      }}
    >
      <Box component="span" sx={{ fontSize: "18px", lineHeight: "27px", color: colors.neutral[600] }}>
        {label}
      </Box>
      <Box component="span" sx={{ fontSize: "16px", lineHeight: "22px", color: colors.neutral.white }}>
        {usedLabel}
      </Box>
    </Box>
    <Box
      sx={{
        position: "relative",
        height: "6px",
        borderRadius: "3px",
        backgroundColor: colors.card.progressTrack,
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: `${Math.min(pct, 100)}%`,
          borderRadius: "3px",
          backgroundColor: colors.neutral.white,
        }}
      />
    </Box>
  </Box>
);

export default UsageRow;
